import { defineMessages } from 'react-intl';

export default defineMessages({
    gotAQuestion: {
        id: 'media_sidebar.text.sections.media_sidebar_example.title',
        defaultMessage: 'Got a Question?',
    },
    gotAQuestionContent: {
        id: 'media_sidebar.text.sections.media_sidebar_example.content',
        defaultMessage:
            'Our FAQ page contains answers to the questions we get asked the most. Find out if your question is included there.',
    },
    faq: {
        id: 'media_sidebar.text.sections.media_sidebar_example.link_name',
        defaultMessage: 'FAQ',
    },
    gotAQuestionTwia: {
        id: 'twia.media_sidebar.text.sections.title',
        defaultMessage: 'Welcome',
    },
    gotAQuestionContentTwia: {
        id: 'twia.media_sidebar.text.sections.content',
        defaultMessage:
            'For training guides and additional resources, please visit our',
    },
    faqTwia: {
        id: 'twia.media_sidebar.text.sections.link_name',
        defaultMessage: 'resource center',
    },    
    gotAQuestionTfpa: {
        id: 'tfpa.media_sidebar.text.sections.title',
        defaultMessage: 'Welcome',
    },
    gotAQuestionContentTfpa: {
        id: 'tfpa.media_sidebar.text.sections.content',
        defaultMessage:
            'For training guides and additional resources, please visit our',
    },
    faqTfpa: {
        id: 'tfpa.media_sidebar.text.sections.link_name',
        defaultMessage: 'resource center',
    },     
});
